/*
 * @Description:
 * @Date: 2021-07-21 16:09:31
 */
import { customerUser } from '@/api/ajax';
import { syncUserInfo } from '@/utils/storage';
import { jumpBeforeRegisterUrl } from '@/utils/storage';

export const verifyLoginService = async function(phone, verifyCode) {
  const {
    data: { data }
  } = await customerUser.verifyLogin({
    phone,
    verifyCode
  });
  let { token, user, channel, tJhEnterpriseChannelWhiteList } = data;
  user.token = token;
  await syncUserInfo(user);
  this.$sa.login(user.id);
  if (channel.userPerfectType === 1 && !user.fullName) {
    this.$router.push({
      name: 'perfect'
    });
  } else if (channel.visitRestrictType === 3) {
    this.$router.push({
      name: 'word'
    });
  } else if (
    channel.visitRestrictType === 4 &&
    !tJhEnterpriseChannelWhiteList
  ) {
    //不在白名单里面
    this.$router.push({
      name: 'word'
    });
  } else {
    let jumpUrl = jumpBeforeRegisterUrl();
    if (!jumpUrl) {
      this.$router.push({
        name: 'home'
      });
    }
  }
};

export const yshLogin = function() {
  const { phone, from } = this.$route.query;
  if (from === 'ysh') {
    verifyLoginService.call(this, phone);
  }
};
